import Vue from 'vue';

import { Initializer } from '../interfaces/general';

export default class SectionBlendingInitializer implements Initializer {
  public mount($: JQueryStatic, app: Vue) {
    const small = $("section.blend-top-in-small");
    const medium = $("section.blend-top-in-medium");
    const large = $("section.blend-top-in-large");

    small.prev().addClass("blend-next-small");
    medium.prev().addClass("blend-next-medium");
    large.prev().addClass("blend-next-large");
  }

  public unmount() {
    // nope
  }
}
